/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import type { ContentStackProductGrid } from '../../interface/content-types';
import { CMSHeadline } from '../CMSHeadline/CMSHeadline';
import { Grid } from '@/components/Grid';
import { CMSProductCard } from './components/CMSProductCard';
import styles from './CMSProductTypeGrid.module.scss';
import cx from 'classnames';

type Props = {
  content: ContentStackProductGrid;
  gridIndex: number;
};

const gridSpacingForLayout: Record<ContentStackProductGrid['layout'], number> = {
  Two: 6,
  Three: 4,
  Four: 3,
};

export const CMSProductTypeGrid = (props: Props) => {
  const {
    content: {
      headline,
      headline_emphasized,
      layout,
      mobile_horizontal_scroll_disabled,
      mobile_single_column,
      product_card,
      product_details_alignment,
    },
    gridIndex,
  } = props;
  const mobileColumn = mobile_single_column ? 12 : 6;

  const isHorizontalScrollEnabled = !mobile_horizontal_scroll_disabled;

  return (
    <section>
      {headline ? (
        <CMSHeadline emphasize={headline_emphasized ? 'last' : undefined}>{headline}</CMSHeadline>
      ) : null}
      <Grid
        container
        justify="flex-start"
        data-testid={`product-grid-${gridIndex}`}
        className={cx({ [styles.mobileScrollContainer]: isHorizontalScrollEnabled })}
      >
        {product_card?.map((singleProduct) => (
          <Grid
            item
            sm={isHorizontalScrollEnabled ? false : mobileColumn}
            md={gridSpacingForLayout[layout]}
            key={singleProduct.product_name}
            className={cx(styles.item, { [styles.mobileScrollItem]: isHorizontalScrollEnabled })}
          >
            <CMSProductCard
              product={singleProduct}
              detailsAlignment={product_details_alignment}
              isHorizontalScrollEnabled={isHorizontalScrollEnabled}
            />
          </Grid>
        ))}
      </Grid>
    </section>
  );
};
